export const whatWentWrongData = {
  title: 'Please tell us where the item was left and what went wrong?',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/b9e9d5194028-tooliconbox.jpg',
    alt: '',
  },
  descriptiveText: [
    'What you write here will appear in the final letter of claim, so please be as clear as possible, including dates.',
  ],
  placeholderText:
    'Eg. The courier said they left it in my shed but it was not there when I returned home.',
}
